import ExportEventsFilters from 'components/export/ExportEventsFilters';
import { Column } from 'primereact/column';
import { FC, useEffect, useState } from 'react';
import exportEventsStore from 'store/ExportEventsStore';
import { observer } from 'mobx-react';
import { DataTable } from 'components/base/DataTable';
import { LoadingStatus } from 'enums';
import Spinner from 'components/base/spinner';
import { Paginator, PaginatorPageState } from 'primereact/paginator';
import { EventsFilters as ExportEventsFiltersType } from 'types/exportEvents';
import {
  DateBodyTemplate,
  DefaultBodyTemplate,
  InputTypeBodyTemplate,
} from 'components/export/ExportEventsColumnsBodyTemplates';

const ExportEventsPage: FC = () => {
  // const navigation = useNavigate();
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [rows, setRows] = useState<number>(10);
  const [filters, setFilters] = useState<ExportEventsFiltersType>({});

  useEffect(() => {
    exportEventsStore.fetchEvents({ page: 1, size: 10 });
  }, []);

  const handlePageChange = (event: PaginatorPageState) => {
    setCurrentPage(event.page);
    setRows(event.rows);
    exportEventsStore.fetchEvents({
      page: event.page + 1,
      size: 10,
      ...filters,
    });
  };

  // const handleClickExcel = () => {
  //   exportEventsStore.fetchEventsExcel();
  // };

  return (
    <>
      <h1 className="mb-5">События</h1>
      {/* <div className="mb-4">
        <ActionButtons
          textButtonSuccess="Выгрузить excel"
          onClickSuccessButton={handleClickExcel}
          onClickBackButton={() => navigation(EXPORT_R00T_ROUTE)}
        />
      </div> */}
      <ExportEventsFilters
        setFilters={setFilters}
        setCurrentPage={setCurrentPage}
        setRows={setRows}
        filters={filters}
      />
      {exportEventsStore.status === LoadingStatus.DONE ? (
        <>
          <DataTable
            value={exportEventsStore.events}
            rows={10}
            responsiveLayout="stack"
          >
            <Column
              field="email"
              header="Email пользователя"
              body={DefaultBodyTemplate}
            />
            <Column
              field="glucometerSerialNumber"
              header="Серийный номер глюкометра"
              body={DefaultBodyTemplate}
            />
            <Column
              field="type"
              header="Тип измерения"
              body={DefaultBodyTemplate}
            />
            <Column
              field="glucoseValue"
              header="Значение измерения глюкозы"
              body={DefaultBodyTemplate}
            />
            <Column
              field="inputType"
              header="Тип добавления измерения"
              body={InputTypeBodyTemplate}
            />
            <Column
              field="mealTag"
              header="Флаг приема пищи"
              body={DefaultBodyTemplate}
            />
            <Column
              field="additionalTime"
              header="Время создания измерения"
              body={DateBodyTemplate}
            />
            <Column
              field="createdAt"
              header="Дата сохранения измерения"
              body={DateBodyTemplate}
            />
            <Column
              field="modifiedAt"
              header="Дата последнего изменения измерения"
              body={DateBodyTemplate}
            />
          </DataTable>
          <Paginator
            rows={rows}
            first={currentPage * rows}
            totalRecords={exportEventsStore.totalPages}
            onPageChange={handlePageChange}
          />
        </>
      ) : (
        <Spinner />
      )}
    </>
  );
};

const ExportEventsPageObserver = observer(ExportEventsPage);

export { ExportEventsPageObserver as ExportEventsPage };
